import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {Lookups} from "@model";
import {getLanguageValue} from "@utility";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-language-output',
  templateUrl: './language-output.component.html',
  styleUrls: ['./language-output.component.scss']
})
export class LanguageOutputComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input() hrLabel?: string | undefined;
  @Input() enLabel?: string | undefined;
  @Input() siLabel?: string | undefined;
  @Input() itLabel?: string | undefined;
  @Input() defaultLanguage?: number | undefined;
  @Input() defaultLabel?: string | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() defaultLanguageCode: string | undefined;
  @Input() showAsInnerHtml: boolean | undefined;

  constructor(private translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.setDefaultLanguage();
  }

  private setDefaultLanguage(): void {
    if (this.languages && this.languages.length > 0) {
      let defaultLang;
      if (this.defaultLanguage) {
        defaultLang = this.languages.filter((language: Lookups) => language?.id === this.defaultLanguage)[0];
      } else {
        defaultLang = this.languages.filter((language: Lookups) => language?.code === this.translocoService.getActiveLang())[0];
      }
      this.defaultLanguageCode = defaultLang?.code ?? "hr";
    }
  }


  getLabel(): string {
    if (this.hrLabel) {
      this.defaultLanguageCode = 'hr';
    } else if (this.enLabel) {
      this.defaultLanguageCode = 'en';
    } else if (this.itLabel) {
      this.defaultLanguageCode = 'it';
    } else if (this.siLabel) {
      this.defaultLanguageCode = 'si';
    }
    var label: string = getLanguageValue(this.hrLabel, this.enLabel, this.itLabel, this.siLabel, this.translocoService.getActiveLang()) ?? "";
    if (label === "" && this.defaultLanguageCode) {
      label = getLanguageValue(this.hrLabel, this.enLabel, this.itLabel, this.siLabel, this.defaultLanguageCode) ?? "";
    }
    if (label === "") {
      label = getLanguageValue(this.hrLabel, this.enLabel, this.itLabel, this.siLabel, "hr") ?? "";
    }
    if (label === "" && this.defaultLabel) {
      label = this.defaultLabel;
    }
    return label;
  }
}
